import { render, staticRenderFns } from "./DropzoneField.vue?vue&type=template&id=47f11c04&scoped=true&"
import script from "./DropzoneField.vue?vue&type=script&lang=js&"
export * from "./DropzoneField.vue?vue&type=script&lang=js&"
import style0 from "./DropzoneField.vue?vue&type=style&index=0&id=47f11c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f11c04",
  null
  
)

export default component.exports